import FilterPanel from "./SearchFilter";
import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Circle,
} from "@react-google-maps/api";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import "../assets/css/GoogleMap.css";
import LogoPostperty from "../assets/markerIcon/production/1. LOGO-Postperty.webp";
import debounce from "lodash/debounce";
import { MoonLoader } from "react-spinners";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { BiSearch } from "react-icons/bi";

// Marker Icons
import HousePostperty from "../assets/markerIcon/production/1HousePostperty.webp";
import CondoPostperty from "../assets/markerIcon/production/2CondoPostperty.webp";
import CommercialPostperty from "../assets/markerIcon/production/4CommercePostperty.webp";
import LandPostperty from "../assets/markerIcon/production/3LandPostperty.webp";
import TownHousePostperty from "../assets/markerIcon/production/5TownHouse_postperty.webp";
import OtherPostperty from "../assets/markerIcon/production/6OtherPostperty.png";

// Golden Markers
import HouseGolden from "../assets/markerIcon/golden_marker1.png";
import CommercialGolden from "../assets/markerIcon/golden_marker2.png";
import CondoGolden from "../assets/markerIcon/golden_marker3.png";
import LandGolden from "../assets/markerIcon/golden_marker4.png";
import TownHouseGolden from "../assets/markerIcon/golden_marker5.png";
import FactoryGolden from "../assets/markerIcon/golden_marker6.png";

import { motion } from "framer-motion";
import useEffectOnce from "../../../shared/hooks/useEffectOnce";
import ModalDetail from "./PropertyModal";

// NEW: Viewport-based marker loading hooks
import { useMapViewport } from '../hooks/useMapViewport';
import { useMarkerLoader } from '../hooks/useMarkerLoader';

const session_id = Cookies.get("jwt");

function GoogleMapEmbedAPIReact({
  statusHalfGridMap,
  setStatusHalfGridMap,
  statusCloseMap,
  SetStatusCloseMap,
  isFullGridButtonOn,
  setIsFullGridButtonOn,
  setDataSearchValue,
  setSearchValue,
  statusInSessionCloseMap,
  setDataDisplay,
  setIsExpanded,
  isExpanded,
  setHeightStep,
  heightStep,
  mainDataModal,
  setMainDataModal,
}) {
  // ======================== MAP STATE (must be declared first) ========================
  const [map, setMap] = React.useState(null);
  const mapRef = useRef(null);

  // ======================== NEW: VIEWPORT-BASED MARKER LOADING ========================
  const {
    markers: viewportMarkers,
    gridData: loadedGridData,
    isLoading: isLoadingMarkersNew,
    loadMarkers,
    clearCache
  } = useMarkerLoader();

  const { viewport, zoom: currentZoom } = useMapViewport(map, 500);

  // Manual markers override (for filter search, text search, circle mode)
  const [manualMarkers, setManualMarkers] = useState(null);

  // Use manual markers if set, otherwise use viewport markers
  const markersData = manualMarkers || viewportMarkers;

  // ======================== CORE STATES ========================
  const [selectedMarker, setSelectedMarker] = useState("");
  const [statusMap, setStatusMap] = useState("");
  const [currentLocation, setCurrentLocation] = useState({});
  const [realtimeLocation, setRealtimeLocation] = useState({
    lat: 13.787304308779046,
    lng: 100.03521153226723,
  });
  const [loadingData, setLoadingData] = useState(false);
  const [isLoadingMarker, setIsLoadingMarker] = useState(false);
  const [RadiusCircleMarkerScan, setRadiusCircleMarkerScan] = useState(8);
  const [zoomLevelControl, setZoomLevelControl] = useState(18);
  const [onMarkerScan, SetOnMarkerScan] = useState(false);

  // ======================== SEARCH STATES ========================
  const [MarkerSearchValue, setMarkerSearchValue] = useState(null);
  const [textSearchValue, setTextSearchValue] = useState("");
  const [userBlurSearch, setUserBlurSearch] = useState(false);

  // ======================== MAP STATES ========================
  // NOTE: map and mapRef are now declared at the top of the component
  const [mapCenter, setMapCenter] = useState(() => {
    const storedLat = localStorage.getItem("LatForRecommendedAssets");
    const storedLng = localStorage.getItem("LngForRecommendedAssets");
    return storedLat && storedLng
      ? { lat: parseFloat(storedLat), lng: parseFloat(storedLng) }
      : { lat: 13.820264029261136, lng: 100.03807435273748 };
  });
  const [mapType, setMapType] = useState(
    localStorage.getItem("mapTypeId") || "hybrid"
  );

  // ======================== FILTER STATES ========================
  const [searchDataFilter, setSearchDatafilter] = useState({
    typeRealEstate: [],
    typePostRealEstate: [],
    Province: null,
    Amphure: null,
    Tambon: null,
    statusSeller: null,
    minPrice: null,
    maxPrice: null,
    firstHandRealEstate: null,
    Price: null,
    zipcode: null,
  });
  const [toggleModalDetail, setToggleModalDetail] = useState(false);
  const [isModalSearchFilter, setIsModalSearchFilter] = useState(false);
  const [autoFilterRealEstateValue, setAutoFilterRealEstateValue] = useState(null);
  const [startAutoFilterRealEstate, setStartAutoFilterRealEstate] = useState(false);
  const [stausRoleSellerSearchFilterSelected, setStatusRoleSellerSearchFilterSelected] = useState("");
  const [isStatusRealEstateFirstHand, setIsStatusRealEstateFirstHand] = useState("");
  const [typeRealEstateSelected, setTypeRealEstateSelected] = useState([]);
  const [priceValue, setPriceValue] = useState(null);

  // ======================== ADDRESS STATES ========================
  const [addressData, setAddressData] = useState([]);
  const [provinceData, setProvinceData] = useState([]);
  const [districtsData, setdistrictsData] = useState([]);
  const [TambonData, setTambonData] = useState([]);
  const [RawDataAddressSearchFilter, setRawDataAddressSearchFilter] = useState([]);
  const [provinceFromRawDataAddress, setProvinceFromRawDataAddress] = useState("");
  const [districtFromRawDataAddress, setDistrictFromRawDataAddress] = useState("");

  // ======================== LOCATION & CIRCLE STATES ========================
  const [centerOfMap, setCenterOfMap] = useState(null);
  const [isCheckedCircle, setIsCheckedCircle] = useState(true);
  const [isCheckedFollowRealtimeLocation, setIsCheckedFollowRealtimeLocation] = useState(false);
  const [isSetCenterOfPoint, setIsSetCenterOfPoint] = useState(false);
  const [zoomLevelCurrentOfUser, setZoomLevelCurrentOfUser] = useState(16);
  const [polygonKey, setPolygonKey] = useState(0);

  // ======================== NGIS LAYER STATES ========================
  const [ngisLayerVisible, setNgisLayerVisible] = useState(false);
  const [railwayLayerVisible, setRailwayLayerVisible] = useState(false);
  const [industryLayerVisible, setIndustryLayerVisible] = useState(false);
  const [waterAreasLayerVisible, setWaterAreasLayerVisible] = useState(false);
  const [expresswayLayerVisible, setExpresswayLayerVisible] = useState(false);
  const wmsMapTypeRef = useRef(null);
  const railwayDataRef = useRef(null);
  const waterAreasDataRef = useRef(null);
  const expresswayDataRef = useRef(null);
  const [railwayData, setRailwayData] = useState(null);
  const [waterAreasData, setWaterAreasData] = useState(null);
  const [expresswayData, setExpresswayData] = useState(null);
  const [isNgisExpanded, setIsNgisExpanded] = useState(false);

  // ======================== OTHER STATES ========================
  const [profileData, setProfileData] = useState(null);
  const [assetData, setAssetData] = useState(null);
  const [loading, setLoading] = useState(true);

  // ======================== REFERENCES ========================
  const centerChangedTimeout = useRef(null);
  const elementRef = useRef(null);
  const [constraints, setConstraints] = useState({
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  });

  // ======================== NGIS FUNCTIONS ========================
  const tile2boundingBox = (x, y, z) => {
    const n = Math.pow(2, z);
    const lonLeft = (x / n) * 360 - 180;
    const lonRight = ((x + 1) / n) * 360 - 180;
    const latTop = Math.atan(Math.sinh(Math.PI * (1 - (2 * y) / n))) * (180 / Math.PI);
    const latBottom = Math.atan(Math.sinh(Math.PI * (1 - (2 * (y + 1)) / n))) * (180 / Math.PI);
    
    return {
      west: lonLeft,
      east: lonRight,
      north: latTop,
      south: latBottom
    };
  };

  const createIndustryWMSMapType = () => {
    return new window.google.maps.ImageMapType({
      getTileUrl: function (coord, zoom) {
        const bbox = tile2boundingBox(coord.x, coord.y, zoom);
        const url = `https://dptgis.dpt.go.th/arcgis/services/PLLU_ALLv3/MapServer/WMSServer?` +
          `service=WMS&version=1.3.0&request=GetMap&layers=0&styles=&format=image/png&` +
          `transparent=true&width=256&height=256&crs=EPSG:4326&` +
          `bbox=${bbox.south},${bbox.west},${bbox.north},${bbox.east}`;
        return url;
      },
      tileSize: new window.google.maps.Size(256, 256),
      name: "Thailand Industry Land Use",
      maxZoom: 18,
      minZoom: 6,
      opacity: 0.7
    });
  };

  const fetchRailwayData = async () => {
    try {
      const response = await fetch(
        'https://ngis.go.th/arcgis/rest/services/Hosted/เส้นทางรถไฟ/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson'
      );
      const data = await response.json();
      setRailwayData(data);
      return data;
    } catch (error) {
      console.error('Error fetching railway data:', error);
      return null;
    }
  };

  const fetchWaterAreasData = async () => {
    try {
      const response = await fetch(
        'https://ngis.go.th/arcgis/rest/services/Hosted/พื้นที่แหล่งน้ำธรรมชาติกรุงเทพมหานคร/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson'
      );
      const data = await response.json();
      setWaterAreasData(data);
      return data;
    } catch (error) {
      console.error('Error fetching water areas data:', error);
      return null;
    }
  };

  const fetchExpresswayData = async () => {
    try {
      const response = await fetch(
        'https://giportal.mot.go.th/arcgis/rest/services/Hosted/เส้นทางด่วน_กทพ/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson'
      );
      const data = await response.json();
      setExpresswayData(data);
      return data;
    } catch (error) {
      console.error('Error fetching expressway data:', error);
      return null;
    }
  };


  const toggleRailwayLayer = () => {
    if (!map) return;

    if (railwayLayerVisible) {
      // Remove railway layer
      if (railwayDataRef.current) {
        map.data.forEach((feature) => {
          map.data.remove(feature);
        });
      }
    } else {
      // Add railway layer
      if (railwayData) {
        displayRailwayData(railwayData);
      } else {
        fetchRailwayData().then((data) => {
          if (data) displayRailwayData(data);
        });
      }
    }
    setRailwayLayerVisible(!railwayLayerVisible);
  };

  const displayRailwayData = (data) => {
    if (!map || !data) return;

    map.data.addGeoJson(data);
    applyAllLayerStyles();
  };

  const toggleWaterAreasLayer = () => {
    if (!map) return;

    if (waterAreasLayerVisible) {
      // Remove water areas layer
      if (waterAreasDataRef.current) {
        map.data.forEach((feature) => {
          const waterBodyType = feature.getProperty('wb_type');
          if (waterBodyType === 6 || waterBodyType === 7) { // Water body types
            map.data.remove(feature);
          }
        });
      }
    } else {
      // Add water areas layer
      if (waterAreasData) {
        displayWaterAreasData(waterAreasData);
      } else {
        fetchWaterAreasData().then((data) => {
          if (data) displayWaterAreasData(data);
        });
      }
    }
    setWaterAreasLayerVisible(!waterAreasLayerVisible);
  };

  const displayWaterAreasData = (data) => {
    if (!map || !data) return;

    waterAreasDataRef.current = data;
    map.data.addGeoJson(data);
    applyAllLayerStyles();
  };

  const toggleExpresswayLayer = () => {
    if (!map) return;

    if (expresswayLayerVisible) {
      // Remove expressway layer
      if (expresswayDataRef.current) {
        map.data.forEach((feature) => {
          const expresswayRoute = feature.getProperty('route');
          const expresswayName = feature.getProperty('centerline');
          if (expresswayRoute && expresswayName && feature.getGeometry().getType().includes('LineString')) {
            map.data.remove(feature);
          }
        });
      }
    } else {
      // Add expressway layer
      if (expresswayData) {
        displayExpresswayData(expresswayData);
      } else {
        fetchExpresswayData().then((data) => {
          if (data) displayExpresswayData(data);
        });
      }
    }
    setExpresswayLayerVisible(!expresswayLayerVisible);
  };

  const displayExpresswayData = (data) => {
    if (!map || !data) return;

    expresswayDataRef.current = data;
    map.data.addGeoJson(data);
    applyAllLayerStyles();
  };

  // Unified function to apply styles to all layer types
  const applyAllLayerStyles = () => {
    if (!map) return;
    
    map.data.setStyle((feature) => {
      // Check for expressway features
      const expresswayRoute = feature.getProperty('route');
      const expresswayName = feature.getProperty('centerline');
      
      // Check for railway features  
      const railwayMainName = feature.getProperty('main_namt') || feature.getProperty('main_name');
      
      // Check for water areas features (using properties from NGIS Bangkok water data)
      const waterBodyType = feature.getProperty('wb_type');
      
      const geomType = feature.getGeometry().getType();
      
      // Style expressway features
      if (expresswayRoute && geomType.includes('LineString')) {
        return {
          strokeColor: '#9013FE', // Purple color for expressways
          strokeWeight: 4,
          strokeOpacity: 0.8,
        };
      }
      
      // Style railway features
      if (railwayMainName && geomType.includes('LineString')) {
        const direction = feature.getProperty('direction') || feature.getProperty('sub_namt') || feature.getProperty('sub_name') || '';
        let color;
        switch (direction.charAt(0).toUpperCase()) {
          case 'S': color = '#4ECDC4'; break; // South - Teal
          case 'N': color = '#45B7D1'; break; // North - Blue  
          case 'NE': color = '#96CEB4'; break; // Northeast - Green
          case 'E': color = '#FFEAA7'; break; // East - Yellow
          default: color = '#FF6B6B'; break; // Default - Red
        }
        return {
          strokeColor: color,
          strokeWeight: 3,
          strokeOpacity: 0.8,
        };
      }
      
      // Style water areas features
      if (waterBodyType && (geomType.includes('Polygon') || geomType.includes('MultiPolygon'))) {
        let fillColor = '#4A90E2'; // Default water blue
        let strokeColor = '#2171B5';
        
        // Different colors for different water body types
        switch(waterBodyType) {
          case 6: // สระ (Pond)
            fillColor = '#4A90E2';
            strokeColor = '#2171B5';
            break;
          case 7: // อ่างเก็บน้ำ (Reservoir)
            fillColor = '#1E88E5';
            strokeColor = '#0D47A1';
            break;
          default:
            fillColor = '#4A90E2';
            strokeColor = '#2171B5';
            break;
        }
        
        return {
          fillColor: fillColor,
          fillOpacity: 0.6,
          strokeColor: strokeColor,
          strokeWeight: 2,
          strokeOpacity: 0.8,
        };
      }
      
      // Hide other features
      return {
        visible: false
      };
    });
  };

  // Unified click listener for all NGIS layers
  const setupNgisClickListener = () => {
    if (!map) return;
    
    map.data.addListener('click', (event) => {
      const feature = event.feature;
      const geomType = feature.getGeometry().getType();
      
      // Check for different layer types
      const expresswayRoute = feature.getProperty('route');
      const expresswayName = feature.getProperty('centerline');
      const railwayMainName = feature.getProperty('main_namt') || feature.getProperty('main_name');
      const railwaySubName = feature.getProperty('sub_namt') || feature.getProperty('sub_name');
      const waterBodyType = feature.getProperty('wb_type');
      
      if (expresswayRoute && expresswayName && geomType.includes('LineString')) {
        const length = feature.getProperty('SHAPE__Length');
        
        const infoWindow = new window.google.maps.InfoWindow({
          content: `
            <div class="p-4 max-w-xs">
              <h3 class="font-bold text-purple-800 text-lg mb-2">🛣️ ${expresswayName}</h3>
              <div class="space-y-1 text-sm text-gray-700">
                <p><span class="font-semibold">ประเภท:</span> เส้นทางด่วน กรุงเทพฯ</p>
                <p><span class="font-semibold">รหัสเส้นทาง:</span> ${expresswayRoute}</p>
                ${length ? `<p><span class="font-semibold">ความยาว:</span> ${Number(length * 111000).toLocaleString()} ม.</p>` : ''}
                <p class="text-xs text-purple-600 mt-2">ข้อมูลจาก กทพ. (กรุงเทพมหานครและปริมณฑล)</p>
              </div>
            </div>
          `,
          position: event.latLng
        });
        infoWindow.open(map);
      } else if (railwayMainName && geomType.includes('LineString')) {
        const infoWindow = new window.google.maps.InfoWindow({
          content: `
            <div class="p-3">
              <h3 class="font-bold text-blue-800">${railwayMainName}</h3>
              <p class="text-sm text-gray-600">${railwaySubName}</p>
            </div>
          `,
          position: event.latLng
        });
        infoWindow.open(map);
      } else if (waterBodyType && (geomType.includes('Polygon') || geomType.includes('MultiPolygon'))) {
        const waterBodyName = feature.getProperty('wb_name_t') || 'ไม่ระบุชื่อ';
        const waterBodyTypeText = waterBodyType === 6 ? 'สระ' : 'อ่างเก็บน้ำ';
        const area = feature.getProperty('SHAPE__Area');
        const length = feature.getProperty('SHAPE__Length');
        
        const infoWindow = new window.google.maps.InfoWindow({
          content: `
            <div class="p-4 max-w-xs">
              <h3 class="font-bold text-blue-800 text-lg mb-2">🌊 ${waterBodyName}</h3>
              <div class="space-y-1 text-sm text-gray-700">
                <p><span class="font-semibold">ประเภท:</span> ${waterBodyTypeText}</p>
                ${area ? `<p><span class="font-semibold">พื้นที่:</span> ${Number(area).toLocaleString()} ตร.ม.</p>` : ''}
                ${length ? `<p><span class="font-semibold">เส้นรอบรูป:</span> ${Number(length).toLocaleString()} ม.</p>` : ''}
                <p class="text-xs text-blue-600 mt-2">ข้อมูลจาก NGIS กรุงเทพมหานคร</p>
              </div>
            </div>
          `,
          position: event.latLng
        });
        infoWindow.open(map);
      }
    });
  };

  const toggleIndustryLayer = () => {
    if (!map) return;

    if (industryLayerVisible) {
      map.overlayMapTypes.removeAt(0);
    } else {
      if (!wmsMapTypeRef.current) {
        wmsMapTypeRef.current = createIndustryWMSMapType();
      }
      map.overlayMapTypes.insertAt(0, wmsMapTypeRef.current);
    }
    setIndustryLayerVisible(!industryLayerVisible);
  };

  const toggleNgisPanel = () => {
    setIsNgisExpanded(!isNgisExpanded);
  };

  // ======================== UTILITY FUNCTIONS ========================
  const checkLogin = () => {
    const session_id = Cookies.get("jwt");
    return session_id;
  };

  const typeToIcon = {
    house: HousePostperty,
    condo: CondoPostperty,
    land: LandPostperty,
    commercial: CommercialPostperty,
    townhouse: TownHousePostperty,
    other: OtherPostperty
  };

  const typeGoldenmarkerIcon = {
    house: HouseGolden,
    condo: CondoGolden,
    land: LandGolden,
    commercial: CommercialGolden,
    townhouse: TownHouseGolden,
    other: FactoryGolden
  };

  const handleTypeIcons = (markerData) => {
    if (markerData.official == true && markerData.imperfect_asset == false) {
      if (markerData.sold == false) {
        return typeGoldenmarkerIcon[markerData.type];
      }
    }
    return typeToIcon[markerData.type];
  };

  const latitudeCenter = "lat" in currentLocation;
  const longtitudeCenter = "lng" in currentLocation;

  const center = {
    lat:
      selectedMarker !== ""
        ? selectedMarker.location
        : latitudeCenter === true
          ? currentLocation.lat
          : 13.820264029261136,
    lng:
      selectedMarker !== ""
        ? selectedMarker.location
        : longtitudeCenter === true
          ? currentLocation.lng
          : 100.03807435273748,
  };

  // ======================== MAP FUNCTIONS ========================
  const changeStatusMap = () => {
    setStatusHalfGridMap(false);
    SetStatusCloseMap(true);
    setIsFullGridButtonOn(true);
    const url = new URL(window.location);
    url.searchParams.set("gridDisplay", "true");
    window.history.pushState({}, "", url);
  };

  const panToUserLocation = () => {
    onCenterChanged();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          if (pos.lat !== undefined && pos.lng !== undefined) {
            setCurrentLocation(pos);
            localStorage.setItem("LatForRecommendedAssets", pos.lat);
            localStorage.setItem("LngForRecommendedAssets", pos.lng);

            if (mapRef.current) {
              mapRef.current.panTo({ lat: pos.lat, lng: pos.lng });
              mapRef.current.setZoom(14);
            } else {
              console.error("mapRef.current is undefined");
            }
          } else {
            console.error("Latitude is undefined");
          }
        },
        (positionError) => {
          // Handle error silently
        },
        { enableHighAccuracy: true }
      );
    } else {
      Swal.fire("ไม่สำเร็จ", "ไม่ซัพพอร์ทเบราว์เซอร์ของคุณ", "error");
    }
  };

  const panToUserLocationFix = (lat, lng) => {
    onCenterChanged();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          if (lat !== undefined && lng !== undefined) {
            setCurrentLocation(pos);
            localStorage.setItem("LatForRecommendedAssets", pos.lat);
            localStorage.setItem("LngForRecommendedAssets", pos.lng);

            if (mapRef.current) {
              mapRef.current.panTo({ lat: lat, lng: lng });
              mapRef.current.setZoom(14);
            } else {
              console.error("mapRef.current is undefined");
            }
          } else {
            console.error("Latitude is undefined");
          }
        },
        (positionError) => {
          // Handle error silently
        },
        { enableHighAccuracy: true }
      );
    } else {
      Swal.fire("ไม่สำเร็จ", "ไม่ซัพพอร์ทเบราว์เซอร์ของคุณ", "error");
    }
  };

  const changeMapType = async (newMapType) => {
    await setMapType(newMapType);
    localStorage.setItem("mapTypeId", newMapType);
  };

  const handleChangeTypeOfGoogleMap = () => {
    if (mapType === "hybrid") {
      changeMapType("terrain");
    } else if (mapType === "terrain") {
      changeMapType("hybrid");
    } else {
      changeMapType("hybrid");
    }
  };

  // ======================== SEARCH FUNCTIONS ========================
  const handleValueSearch = (e) => {
    const textSearch = e.target.value;
    setUserBlurSearch(false);
    setTextSearchValue(textSearch);
  };

  const handleSearchValueClicked = () => {
    setIsCheckedCircle(false);
    const searchText = textSearchValue;
    if (searchText.length == 0) {
      setSearchValue("");
    } else if (searchText.length > 1) {
      setSearchValue(searchText);
      setMarkerSearchValue(searchText);
    }
  };

  const getDetailMarker = (id) => {
    setMainDataModal(null);
    axios
      .get(`${process.env.REACT_APP_API}/product/${id}`, {
        headers: {
          Authorization: `Bearer ${session_id}`,
        },
      })
      .then((res) => {
        if (res.data) {
          setMainDataModal(res.data.asset);
          const asset = res.data.asset;
          const coordinates = res.data.asset.location.coordinates;
          map.setCenter(coordinates);
        }
      })
      .catch((err) => {
        console.log("Error fetching marker details:", err);
      });
  };

  const handleMarkerClick = useCallback(
    (marker) => {
      setPolygonKey((prevKey) => prevKey + 1);
      setSelectedMarker(marker);
      setIsExpanded(true);
      setHeightStep("half");
      setToggleModalDetail(true);
      panToUserLocationFix(marker.lat, marker.lng);
      getDetailMarker(marker.id);

      const url = new URL(window.location);
      url.searchParams.set("card", "full");
      url.searchParams.set("aid", marker.id);
      if (marker.lat !== undefined) {
        url.searchParams.set("lat", marker.lat);
      }
      if (marker.lng !== undefined) {
        url.searchParams.set("lng", marker.lng);
      }
      window.history.pushState({}, "", url);
      localStorage.setItem("positionBeforeExitedPage", JSON.stringify(marker));
    },
    [getDetailMarker, setSelectedMarker]
  );

  // ======================== FILTER FUNCTIONS ========================
  async function handleAutoFilterRealEstateSwitchGridModeFromIndexPageIcon() {
    const isAllowGrid = localStorage.getItem(
      "AllowOpenGridLayoutFromAutoFilter_IndexPage"
    );

    if (isAllowGrid == "true") {
      setIsCheckedCircle(false);
      let dataStuct = [];
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const autoFilterValue = urlParams.get("autoFilter");
      dataStuct.push(autoFilterValue);
      await setAutoFilterRealEstateValue(dataStuct);
      if (autoFilterRealEstateValue !== null && autoFilterValue !== null) {
        if (isAllowGrid == "true") {
          changeStatusMap();
          await handleSearchFilther();
          setAutoFilterRealEstateValue(null);
          localStorage.setItem(
            "AllowOpenGridLayoutFromAutoFilter_IndexPage",
            false
          );
        }
      }
    }
  }

  const typerealEstateSearchHandle = (type) => {
    const isSelected = typeRealEstateSelected.includes(type);
    if (isSelected) {
      setSearchDatafilter({
        ...searchDataFilter,
        typeRealEstate: searchDataFilter.typeRealEstate.filter(
          (item) => item !== type
        ),
      });
      setTypeRealEstateSelected(
        typeRealEstateSelected.filter((item) => item !== type)
      );
    } else {
      setSearchDatafilter({
        ...searchDataFilter,
        typeRealEstate: [...searchDataFilter.typeRealEstate, type],
      });
      setTypeRealEstateSelected([...typeRealEstateSelected, type]);
    }
  };

  const handleModalSearch = async () => {
    setLoadingData(true);
    await setManualMarkers([]); // Clear manual markers
    await setIsModalSearchFilter(!isModalSearchFilter);
    setLoadingData(false);
  };

  const RoleSellerEstaeHandle = (type) => {
    setSearchDatafilter({ ...searchDataFilter, statusSeller: type });
    setStatusRoleSellerSearchFilterSelected(type);
  };

  const StatusRealEstateFirstHandHandle = (status) => {
    setSearchDatafilter({ ...searchDataFilter, firstHandRealEstate: status });
    setIsStatusRealEstateFirstHand(status);
  };

  const handleTypePost = (value) => {
    const { typePostRealEstate } = searchDataFilter;
    if (typePostRealEstate.includes(value)) {
      const updatedTypePost = typePostRealEstate.filter(
        (item) => item !== value
      );
      setSearchDatafilter({
        ...searchDataFilter,
        typePostRealEstate: updatedTypePost,
      });
    } else {
      const updatedTypePost = [...typePostRealEstate, value];
      setSearchDatafilter({
        ...searchDataFilter,
        typePostRealEstate: updatedTypePost,
      });
    }
  };

  const getDataAssetsFromFilterSearch = () => {
    axios
      .post(
        `${process.env.REACT_APP_API}/event/query`,
        {
          bedroom: null,
          bathroom: null,
          selltype: searchDataFilter.typePostRealEstate,
          minPrice: searchDataFilter.minPrice,
          maxPrice: searchDataFilter.maxPrice,
          province: searchDataFilter.Province,
          amphure: searchDataFilter.Amphure,
          firsthand: searchDataFilter.firstHandRealEstate,
          seller_status: searchDataFilter.statusSeller,
          type_post: searchDataFilter.typePostRealEstate,
          type:
            autoFilterRealEstateValue !== null
              ? autoFilterRealEstateValue
              : searchDataFilter.typeRealEstate,
        },
        {
          params: {
            sort: "ASC",
            sortPrice: "cheapest",
          },
        }
      )
      .then((res) => {
        const text = res.data.Success;
        const NotFoundAssets = "ไม่พบอสังหาตามความต้องการจากการค้นหาของคุณ";

        if (text !== NotFoundAssets) {
          setDataSearchValue(res.data.Query);
        }
        setIsLoadingMarker(false);

        Swal.fire({
          imageUrl: "https://cdn-icons-png.flaticon.com/512/1040/1040999.png",
          imageWidth: 128,
          imageHeight: 128,
          html: `ค้นพบจำนวนอสังหาฯที่ท่านค้นหา<br>${res.data.Query.length} รายการ`,
          confirmButtonText: "ทราบแล้ว",
          icon: text === NotFoundAssets ? "warning" : null,
          timer: 4000,
          timerProgressBar: true,
          didOpen: (popup) => {
            Swal.showLoading();
          },
          willClose: () => {
            // Do something when the alert is about to close
          },
        });
      })
      .catch((error) => {
        console.error(error);
        Swal.fire("ไม่สำเร็จ", "เกิดข้อผิดพลาด", "error");
      });
  };

  function getMarkersFromFilterSearch() {
    setIsLoadingMarker(true);

    axios
      .post(
        `${process.env.REACT_APP_API}/event/queryMarker`,
        {
          bedroom: null,
          bathroom: null,
          selltype: searchDataFilter.typePostRealEstate,
          minPrice: searchDataFilter.minPrice,
          maxPrice: searchDataFilter.maxPrice,
          province: searchDataFilter.Province,
          amphure: searchDataFilter.Amphure,
          firsthand: searchDataFilter.firstHandRealEstate,
          seller_status: searchDataFilter.statusSeller,
          type_post: searchDataFilter.typePostRealEstate,
          type:
            autoFilterRealEstateValue !== null
              ? autoFilterRealEstateValue
              : searchDataFilter.typeRealEstate,
        },
        {
          params: {
            sort: "ASC",
            sortPrice: "cheapest",
          },
        }
      )
      .then((res) => {
        const markersFilter = res.data.Markers;
        setManualMarkers(markersFilter); // Override with filter results

        if (markersFilter.length > 0) {
          const marker = markersFilter[0];
          setSelectedMarker(marker);
          getDetailMarker(marker.id);
          localStorage.setItem(
            "positionBeforeExitedPage",
            JSON.stringify(marker)
          );

          const delay =
            markersFilter.length > 2000
              ? 12000
              : markersFilter.length < 400
                ? 5000
                : 4500;
          setTimeout(() => {
            setIsLoadingMarker(false);
          }, delay);
        } else {
          setIsLoadingMarker(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleSearchFilther = () => {
    setIsModalSearchFilter(false);
    setIsCheckedCircle(false);
    getDataAssetsFromFilterSearch();
    getMarkersFromFilterSearch();
    setSearchDatafilter({
      ...searchDataFilter,
      Province: null,
      Amphure: null,
      Tambon: null,
    });
  };

  function handlePriceSearch(e) {
    const value = e.target.value;
    if (value == "1M") {
      setSearchDatafilter({
        ...searchDataFilter,
        minPrice: 0,
        maxPrice: 1000000,
      });
    } else if (value == "1MT3") {
      setSearchDatafilter({
        ...searchDataFilter,
        minPrice: 1000001,
        maxPrice: 3000000,
      });
    } else if (value == "3MT5") {
      setSearchDatafilter({
        ...searchDataFilter,
        minPrice: 3000001,
        maxPrice: 5000000,
      });
    } else if (value == "5MT10") {
      setSearchDatafilter({
        ...searchDataFilter,
        minPrice: 5000001,
        maxPrice: 10000000,
      });
    } else if (value == "Morethan10m") {
      setSearchDatafilter({
        ...searchDataFilter,
        minPrice: 10000000,
        maxPrice: 10000000000,
      });
    }
  }

  function handleClearFilterSearch() {
    setSearchDatafilter({
      typeRealEstate: [
        "house",
        "condo",
        "commercial",
        "land",
        "townhouse",
        "other",
      ],
      typePostRealEstate: [],
      Province: null,
      Amphure: null,
      Tambon: null,
      statusSeller: null,
      minPrice: null,
      maxPrice: null,
      firstHandRealEstate: null,
      Price: null,
      zipcode: null,
    });

    setTypeRealEstateSelected([
      "house",
      "condo",
      "commercial",
      "land",
      "townhouse",
      "other",
    ]);
    setStatusRoleSellerSearchFilterSelected("");
    setIsStatusRealEstateFirstHand("");
    Swal.fire("", "เลือกประเภทอสังหาฯทั้งหมดเรียบร้อย", "success");
  }

  // ======================== ADDRESS FUNCTIONS ========================
  function handleCallAmpuhre(IDProvinceUserSelected) {
    if (IDProvinceUserSelected !== "") {
      const selectedProvince = provinceData.find(
        (province) => province.id == IDProvinceUserSelected
      );

      if (selectedProvince) {
        setSearchDatafilter({
          ...searchDataFilter,
          Province: selectedProvince.name_th,
        });
        setdistrictsData(selectedProvince.amphure);
      }
    }
  }

  function handleCallTambon(IDAmpuhreUserSelected) {
    const selectedAmphure = districtsData.find(
      (district) => district.id == IDAmpuhreUserSelected
    );
    if (selectedAmphure) {
      setSearchDatafilter({
        ...searchDataFilter,
        Amphure: selectedAmphure.name_th,
      });
      setTambonData(selectedAmphure.tambon);
    }
  }

  function handleSetTambonSearchDataFilter(name_th) {
    setSearchDatafilter({ ...searchDataFilter, Tambon: name_th });
  }

  const callZipcode = async (zipcodeRaw) => {
    if (zipcodeRaw.length === 5) {
      axios
        .post(`${process.env.REACT_APP_API}/fetchData/getQueryLocation`, {
          zipcode: zipcodeRaw,
        })
        .then((res) => {
          setAddressData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleSetTambon = (e) => {
    const tambonFromUser = e.target.value;
    setSearchDatafilter({ ...searchDataFilter, Tambon: tambonFromUser });
  };

  const inputValue = (name) => (e) => {
    setSearchDatafilter({ ...searchDataFilter, [name]: e.target.value });
  };

  const handleRawDataProvinceSelected = async (e) => {
    const province = e.target.value;
    await setProvinceFromRawDataAddress(province);
    await setSearchDatafilter({ ...searchDataFilter, Province: province });
  };

  // ======================== CIRCLE AND MARKER SCAN FUNCTIONS ========================
  const getMarkerFromAreaCircle = () => {
    if (centerOfMap !== null && onMarkerScan == true) {
      axios
        .post(`${process.env.REACT_APP_API}/fetchData/markerScan`, {
          centerLat: centerOfMap.lat,
          centerLng: centerOfMap.lng,
          radiusKm: RadiusCircleMarkerScan,
        })
        .then((res) => {
          setDataSearchValue("");
          setDataDisplay([]);

          setTimeout(() => {
            localStorage.setItem("LatForRecommendedAssets", centerOfMap.lat);
            localStorage.setItem("LngForRecommendedAssets", centerOfMap.lng);
            if (res.data.markers !== markersData) {
              if (res.data.markers.length !== 0) {
                // setIsLoadingMarker(true);
              }
              setManualMarkers(res.data.markers); // Circle mode override
              setDataDisplay(res.data.grid);

              setTimeout(() => {
                setIsLoadingMarker(false);
              }, 600);
            }
          }, 10);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const onCenterChanged = () => {
    if (isSetCenterOfPoint) {
      setIsCheckedFollowRealtimeLocation(true);
      setIsSetCenterOfPoint(false);
    }

    if (isCheckedFollowRealtimeLocation === false) {
      setIsCheckedFollowRealtimeLocation(false);
      setIsSetCenterOfPoint(false);
    }

    if (isCheckedCircle) {
      if (map) {
        const newCenter = map.getCenter().toJSON();
        if (newCenter) {
          setCenterOfMap(newCenter);

          if (centerChangedTimeout.current) {
            clearTimeout(centerChangedTimeout.current);
          }

          centerChangedTimeout.current = setTimeout(async () => {
            if (viewport && currentZoom !== null) {
              await loadMarkers(viewport, currentZoom);
            }
            setIsLoadingMarker(false);
          }, 1000);
        }
      }
    }

    if (heightStep === "half") {
      // setHeightStep("min");
    }
  };

  const handleCheckboxCircleChange = (e) => {
    setIsCheckedCircle(!isCheckedCircle);
  };

  const handleCenterOfPoint = () => {
    setIsSetCenterOfPoint(true);
    if (mapRef.current) {
      mapRef.current.panTo(realtimeLocation);
      mapRef.current.setZoom(zoomLevelCurrentOfUser);
    } else {
      console.error("mapRef.current is undefined");
    }
  };

  const handleRadiusCircleMarkerScan = (event) => {
    const radius = event.target.value;
    if (1 < radius < 5) {
      setZoomLevelControl(10);
    } else {
      setZoomLevelControl(5);
    }
    onCenterChanged();
    setRadiusCircleMarkerScan(radius);
  };

  // ======================== HEIGHT STEP MANAGEMENT ========================
  const updateHeightStep = (newHeightStep) => {
    setHeightStep(newHeightStep);
  };

  useEffect(() => {
    if (map && heightStep) {
      if (heightStep === "min") {
        SetOnMarkerScan(false);
        map.panBy(0, -110);
        updateHeightStep("min");
      } else if (heightStep === "full") {
        map.panBy(0, -110);
        updateHeightStep("full");
      } else if (heightStep === "half") {
        map.panBy(0, +110);
        updateHeightStep("half");
      }
    }

    setTimeout(() => {
      SetOnMarkerScan(true);
    }, 3000);
  }, [heightStep, map]);

  // ======================== GOOGLE MAPS API ========================
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: `${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`,
  });

  const onLoad = React.useCallback(
    function callback(map) {
      const defaultCenter = { lat: 13.756721, lng: 100.03807435273748 };
      const defaultZoomLevel = 14;
      const centerToUse = mapCenter || defaultCenter;

      map.setCenter(centerToUse);
      setZoomLevelControl(defaultZoomLevel);
      const currentCenter = map.getCenter();

      mapRef.current = map;
      setMap(map);
    },
    [mapCenter]
  );

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const handleZoomChanged = debounce(() => {
    const currentZoomLevel = mapRef.current.getZoom();
    setZoomLevelCurrentOfUser(currentZoomLevel);
    setZoomLevelControl(currentZoomLevel);

    if (currentZoomLevel > 10) {
      // Do something when zoom level is greater than 10
    } else {
      // Do something else for other zoom levels
    }
  }, 300);

  const handleClick = useCallback(() => {
    setSelectedMarker("");
    setIsModalSearchFilter(false);
    setUserBlurSearch(true);
  }, []);

  // ======================== EFFECTS ========================
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 769) {
        setStatusMap("desktop");
      }
      if (window.innerWidth < 768) {
        setStatusMap("mobile");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem("mapTypeId", mapType);
    if (map) {
      map.setMapTypeId(mapType);
    }
  }, [mapType, map]);

  // ======================== NEW: VIEWPORT-BASED MARKER LOADING EFFECTS ========================
  // Load markers when viewport or zoom changes
  useEffect(() => {
    if (viewport && currentZoom !== null && onMarkerScan && !isCheckedCircle) {
      console.log('[GoogleMapView] Loading markers for viewport', { viewport, zoom: currentZoom });
      // Clear manual markers override when using viewport mode
      setManualMarkers(null);
      loadMarkers(viewport, currentZoom);
    }
  }, [viewport, currentZoom, onMarkerScan, isCheckedCircle, loadMarkers]);

  // Sync loaded grid data with parent state
  useEffect(() => {
    if (loadedGridData && loadedGridData.length > 0) {
      setDataDisplay(loadedGridData);
    }
  }, [loadedGridData, setDataDisplay]);

  // Clear cache when filters change
  useEffect(() => {
    if (searchDataFilter && Object.keys(searchDataFilter).some(key => searchDataFilter[key])) {
      console.log('[GoogleMapView] Filters changed, clearing cache');
      clearCache();
    }
  }, [searchDataFilter, clearCache]);

  // ======================== OLD: INITIAL LOAD (kept for circle mode fallback) ========================
  useEffect(() => {
    const storedLat = localStorage.getItem("LatForRecommendedAssets");
    const storedLng = localStorage.getItem("LngForRecommendedAssets");

    // Only use old method if circle mode is active
    if (storedLat && storedLng && isCheckedCircle) {
      const centerLat = parseFloat(storedLat);
      const centerLng = parseFloat(storedLng);

      axios
        .post(`${process.env.REACT_APP_API}/fetchData/markerScan`, {
          centerLat,
          centerLng,
          radiusKm: 8,
        })
        .then((response) => {
          if (response.data) {
            setCenterOfMap({ lat: centerLat, lng: centerLng });
            setDataDisplay(response.data.grid || []);
          }
        })
        .catch((err) => {
          console.error("Error fetching markers:", err);
        });
    }
  }, []);

  useEffect(() => {
    panToUserLocation();
  }, []);

  useEffect(() => {
    // Fetch railway data when component mounts
    fetchRailwayData();
    // Fetch water areas data when component mounts
    fetchWaterAreasData();
    // Fetch expressway data when component mounts
    fetchExpresswayData();
    // Setup unified click listener for all NGIS layers
    setupNgisClickListener();
  }, []);

  useEffect(() => {
    return () => {
      if (centerChangedTimeout.current) {
        clearTimeout(centerChangedTimeout.current);
      }
      // Clean up map data when component unmounts
      if (map && (railwayLayerVisible || waterAreasLayerVisible || expresswayLayerVisible)) {
        map.data.forEach((feature) => {
          map.data.remove(feature);
        });
      }
    };
  }, []);

  useEffect(() => {
    setStartAutoFilterRealEstate(true);
  }, []);

  useEffect(() => {
    handleAutoFilterRealEstateSwitchGridModeFromIndexPageIcon();
  }, [startAutoFilterRealEstate]);

  useEffect(() => {
    axios
      .get(
        "https://raw.githubusercontent.com/kongvut/thai-province-data/master/api_province_with_amphure_tambon.json"
      )
      .then((res) => {
        setProvinceData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    const storedMarker = localStorage.getItem("positionBeforeExitedPage");
    if (storedMarker) {
      const marker = JSON.parse(storedMarker);
      setSelectedMarker(marker);
      getDetailMarker(marker.id);
    }
  }, []);

  const confirmShowInfoWindowWithPositionMarkerID = sessionStorage.getItem(
    "confirmShowInfoWindowWithPosition"
  );

  useEffect(() => {
    const storedMarker = localStorage.getItem("positionBeforeExitedPage");
    if (storedMarker && confirmShowInfoWindowWithPositionMarkerID) {
      const marker = JSON.parse(storedMarker);
      setSelectedMarker(marker);
      getDetailMarker(marker.id);
    }
  }, [confirmShowInfoWindowWithPositionMarkerID]);

  // Profile Data Effect
  useEffectOnce(() => {
    const cookie = Cookies.get("jwt");
    const token = `${cookie}`;

    axios
      .get(`${process.env.REACT_APP_API}/user/getDataProfile`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const { uname, profile_image } = res.data;
        setProfileData({
          uname,
          profile_image,
        });
      })
      .catch(function (error) {
        console.error(error);
      });
  });

  // Search Effect
  useEffect(() => {
    const getMarkersFromSearch = () => {
      axios
        .get(
          `${process.env.REACT_APP_API}/event/search-marker/${MarkerSearchValue}`,
          {
            headers: {
              Authorization: `Bearer ${checkLogin()}`,
            },
          }
        )
        .then((res) => {
          const markersSearch = res.data.assets;
          setManualMarkers(markersSearch); // Text search override

          if (markersSearch.length > 0 && userBlurSearch) {
            const marker = markersSearch[0];
            setSelectedMarker(marker);
            getDetailMarker(marker.id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    if (MarkerSearchValue !== null && MarkerSearchValue !== "") {
      getMarkersFromSearch();
    } else {
      setSelectedMarker("");
    }
  }, [MarkerSearchValue, userBlurSearch]);

  // Real-time Location Effect
  useEffect(() => {
    const fetchGeolocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };

            if (pos.lat !== undefined && pos.lng !== undefined) {
              setRealtimeLocation(pos);
              if (mapRef.current && isCheckedFollowRealtimeLocation) {
                mapRef.current.panTo({ lat: pos.lat, lng: pos.lng });
                mapRef.current.setZoom(zoomLevelCurrentOfUser);
              }
            } else {
              console.error("Latitude is undefined");
            }
          },
          (positionError) => {
            console.error(positionError);
          },
          { enableHighAccuracy: true }
        );
      } else {
        console.error("Geolocation is not supported by your browser");
      }
    };

    const fetchInterval = setInterval(fetchGeolocation, 2000);
    return () => clearInterval(fetchInterval);
  }, [isCheckedFollowRealtimeLocation]);

  // URL Parameter Handling
  const useLocationFunc = useLocation();

  const getDetailMarkerMichael = async (aid) => {
    try {
      const response = await fetch(
        `https://api.postperty.com/api/product/${aid}`
      );
      const data = await response.json();
      setAssetData(data.asset);
      setMapCenter(data.asset.location.coordinates);
    } catch (error) {
      console.error("Error fetching asset data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(useLocationFunc.search);
    const aid = params.get("aid");
    const cardStatus = params.get("card");
    const gridDisplay = params.get("gridDisplay");

    if (aid) {
      getDetailMarker(aid);
      setIsExpanded(true);
      getDetailMarkerMichael(aid);

      if (cardStatus == "full") {
        setHeightStep("full");
      } else if (cardStatus == "half") {
        setHeightStep("half");
      } else if (cardStatus == "min") {
        setHeightStep("min");
      }
      setToggleModalDetail(true);
      getDetailMarker(aid);
    }

    if (gridDisplay == "true") {
      setStatusHalfGridMap(false);
      SetStatusCloseMap(true);
      setIsFullGridButtonOn(true);
    } else {
      setStatusHalfGridMap(true);
      SetStatusCloseMap(false);
      localStorage.setItem("tempSwitchToMarkerOfGoogleMap", false);
    }
  }, [useLocationFunc.search]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const card = urlParams.get("card");

    if (card === "full") {
      updateHeightStep("full");
    } else if (card === "half") {
      updateHeightStep("half");
    } else if (card === "min") {
      updateHeightStep("min");
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const inviter = params.get('inviter');
    const sharer = params.get('sharer');

    if (inviter) {
      localStorage.setItem("@ID_INVITER", inviter);
    } else if (sharer) {
      localStorage.setItem("@ID_INVITER", sharer);
    }
  }, []);

  // ======================== MEMOIZED VALUES ========================
  const memoizedMarkersData = useMemo(() => markersData, [markersData]);

  const mapContainerStyle = useMemo(() => {
    const baseStyle = { width: "100vw", height: "100vh" };
    if (statusMap === "desktop") {
      return { ...baseStyle, borderRadius: "1px" };
    }
    return baseStyle;
  }, [statusMap]);

  const memoizedOptions = useMemo(
    () => ({
      disableDefaultUI: true,
      mapTypeId: localStorage.getItem("mapTypeId") || mapType,
      gestureHandling: "greedy",
      clickableIcons: false,
      maxZoom: 20,
      minZoom: 6,
      markerOptions: {
        optimized: true,
      },
    }),
    [mapType]
  );

  // ======================== DRAG CONSTRAINTS ========================
  const dragUpDistance = 70;
  const dragDownDistance = 420;

  useEffect(() => {
    const updateConstraints = () => {
      if (elementRef.current) {
        const { offsetWidth } = elementRef.current;
        setConstraints({
          left: 0,
          right: window.innerWidth + (offsetWidth - 93),
          top: -dragUpDistance,
          bottom: dragDownDistance,
        });
      }
    };

    updateConstraints();
    window.addEventListener("resize", updateConstraints);
    return () => {
      window.removeEventListener("resize", updateConstraints);
    };
  }, [dragUpDistance, dragDownDistance]);

  // ======================== RENDER ========================
  return isLoaded && !loadingData ? (
    <div className="w-full h-screen flex justify-center top-0 sticky">
      {isLoadingMarker && (
        <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-white bg-opacity-75 z-50">
          <MoonLoader size={30} color={"#123abc"} loading={isLoadingMarker} />
          <p className="mt-4 text-lg text-gray-800">ระบบกำลังประมวลผล</p>
        </div>
      )}

      <GoogleMap
        ref={mapRef}
        mapContainerStyle={mapContainerStyle}
        onCenterChanged={onCenterChanged}
        onZoomChanged={handleZoomChanged}
        center={mapCenter}
        zoom={zoomLevelControl}
        onLoad={onLoad}
        onUnmount={onUnmount}
        onClick={handleClick}
        options={memoizedOptions}
      >
        {/* Markers */}
        {memoizedMarkersData.map((marker) => {
          const isSharedMarker = marker.official == true && marker.imperfect_asset == false;
          return (
            <Marker
              key={marker.id}
              position={marker.location}
              onClick={() => handleMarkerClick(marker)}
              icon={{
                url: handleTypeIcons(marker),
                scaledSize: isSharedMarker 
                  ? new window.google.maps.Size(48, 48) 
                  : new window.google.maps.Size(32, 32)
              }}
            />
          );
        })}

        {/* Circle */}
        {/* {isCheckedCircle && (
          <Circle
            center={centerOfMap}
            onClick={() => {
              setSelectedMarker("");
            }}
            radius={RadiusCircleMarkerScan * 1000}
            options={{
              fillColor: "#00b8d2",
              fillOpacity: 0.15,
              strokeColor: "#00b8d2",
              strokeOpacity: 0.8,
              strokeWeight: 2,
            }}
          />
        )} */}

        {/* Modal Detail */}
        {mainDataModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.5 }}
          >
            <ModalDetail
              dataMainModal={mainDataModal}
              id={selectedMarker.id}
              setHeightStep={setHeightStep}
              heightStep={heightStep}
              statusComponent={"map"}
            />
          </motion.div>
        )}

        {/* User Location Marker */}
        <Marker
          key="realtime-location"
          position={realtimeLocation}
          options={{
            icon: {
              url: "https://postpertybucket01.oss-ap-southeast-7.aliyuncs.com/official/media/blue_dot.png",
              scaledSize: new window.google.maps.Size(20, 20),
            },
            zIndex: 9999,
          }}
        />

        {/* Search Header */}
        <div className="w-full h-auto left-1/2 tranform -translate-x-1/2 absolute top-2.5 z-10 md:w-11/12 p-2.5 lg:w-8/12">
          <div className="w-full h-[52px] bg-white rounded-full grid grid-cols-12">
            <Link className="col-span-3 flex items-center justify-center" to={`/`}>
              <div className="flex items-center justify-center">
                <img src={LogoPostperty} className="w-10 h-10" alt="logo-postperty" />
              </div>
            </Link>
            <div className="col-span-6 rounded-full relative">
              <input
                onChange={handleValueSearch}
                onBlur={() => setUserBlurSearch(true)}
                type="text"
                className="w-full h-11/12 my-auto top-1/2 absolute transform -translate-y-1/2 outline-0 text-center"
                placeholder="ค้นหาด้วยคีย์เวิร์ด"
              />
              <BiSearch
                onClick={handleSearchValueClicked}
                className={
                  textSearchValue.length > 0
                    ? "absolute bg-blue-500 top-1/2 right-2 tranform -translate-y-1/2 w-8 h-8 rounded-full text-white p-1 cursor-pointer"
                    : "absolute top-1/2 right-2 tranform -translate-y-1/2 w-6 h-6 cursor-pointer"
                }
              />
            </div>
            <div className="col-span-3 flex items-center justify-center mt-1.5 relative">
              <Link to={`/profiles`}>
                {profileData !== null ? (
                  <img
                    src={profileData.profile_image}
                    alt="profile"
                    className="w-8 h-8 rounded-full"
                  />
                ) : (
                  <img
                    src={"https://cdn-icons-png.flaticon.com/512/2354/2354573.png"}
                    alt="profile"
                    className="w-8 h-8 rounded-full"
                  />
                )}
                <p className="text-[10px] text-center">
                  {profileData !== null ? profileData.uname : <span>Login</span>}
                </p>
              </Link>
            </div>
          </div>

          {/* Control Buttons */}
          <div className="grid grid-cols-12 justify-start mt-2.5 gap-2.5">
            <div className="col-span-4 grid-cols-12 items-center">
              <div
                className="w-full col-span-12 h-[38px] flex text-white bg-postperty-linear-light opacity-95 rounded-full items-center justify-center p-1 cursor-pointer shadow-lg"
                onClick={() => handleModalSearch()}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                    />
                  </svg>
                </div>
                <p className="text-[0.8rem]">ค้นหาทรัพย์</p>
              </div>
            </div>
            <div className="col-span-4 items-center">
              <Link to={`/create/`}>
                <div className="w-full h-[38px] flex bg-important-green text-white rounded-full items-center justify-center p-2">
                  <div className="">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m.75 12l3 3m0 0l3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                      />
                    </svg>
                  </div>
                  <p className="ml-1 text-[0.8rem]">ลงประกาศ</p>
                </div>
              </Link>
            </div>
            <div className="col-span-4 w-full items-center">
              <Link to={checkLogin() === undefined ? "/login" : "/lead/assets/"}>
                <div
                  className={
                    checkLogin() !== undefined
                      ? "w-full h-[38px] flex bg-red-600 text-white rounded-full items-center justify-center shadow-3d"
                      : "w-full h-[38px] flex bg-yellow-700 text-white rounded-full items-center justify-center shadow-3d"
                  }
                >
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                      />
                    </svg>
                  </div>
                  <p className="ml-1">
                    {checkLogin() === undefined ? (
                      <span className="text-[0.7rem]">เข้าระบบ/สมัคร</span>
                    ) : (
                      <span>Lead ทรัพย์</span>
                    )}
                  </p>
                </div>
              </Link>
            </div>
            {/* NGIS Panel Button */}
            <div className="col-span-3 w-full items-center relative">
              <div
                className={`w-full h-[38px] flex rounded-full items-center justify-center p-2 cursor-pointer shadow-lg transition-all duration-300 ${
                  isNgisExpanded || railwayLayerVisible || industryLayerVisible || waterAreasLayerVisible || expresswayLayerVisible
                    ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-blue-200" 
                    : "bg-gradient-to-r from-gray-400 to-gray-500 text-white shadow-gray-200"
                }`}
                onClick={toggleNgisPanel}
              >
                <div className="flex items-center space-x-2">
                 
                  <div className="text-left">
                    <p className="text-[0.7rem] font-medium">NGIS</p>
                    {/* <p className="text-[0.6rem] opacity-80">
                      {railwayLayerVisible || industryLayerVisible ? "กำลังแสดงผล" : "ไม่แสดงผล"}
                    </p> */}
                  </div>
                  <div className={`transform transition-transform duration-300 ${isNgisExpanded ? 'rotate-180' : ''}`}>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div>
              </div>

              {/* NGIS Layers Panel */}
              {isNgisExpanded && (
<div className="hidden sm:block absolute  w-[400px] h-[500px] overflow-y-auto top-12 left-[-5px] bg-white rounded-2xl shadow-2xl border-gray-200 p-4 z-50 transform transition-all duration-300 opacity-100 scale-100">
                  <div className="space-y-4">
                    {/* Header */}
                    <div className="text-center border-b pb-3">
                      <h3 className="text-lg font-bold text-gray-800">ระบบข้อมูลภูมิสารสนเทศ</h3>
                      <p className="text-sm text-gray-600">National Geographic Information System</p>
                    </div>
                    
                    {/* Railway Layer */}
                    <div className="flex items-center justify-between p-3 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl border border-blue-100">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                          <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                          </svg>
                        </div>
                        <div>
                          <p className="font-semibold text-gray-800">เส้นทางรถไฟ</p>
                          <p className="text-xs text-gray-600">แสดงเส้นทางรถไฟทั่วประเทศ</p>
                        </div>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={railwayLayerVisible}
                          onChange={toggleRailwayLayer}
                        />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                      </label>
                    </div>

                    {/* Industry Layer */}
                    <div className="flex items-center justify-between p-3 bg-gradient-to-r from-emerald-50 to-green-50 rounded-xl border border-emerald-100">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center">
                          <svg className="w-5 h-5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                          </svg>
                        </div>
                        <div>
                          <p className="font-semibold text-gray-800">พื้นที่อุตสาหกรรม</p>
                          <p className="text-xs text-gray-600">แสดงการใช้ประโยชน์ที่ดินอุตสาหกรรม</p>
                        </div>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={industryLayerVisible}
                          onChange={toggleIndustryLayer}
                        />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                      </label>
                    </div>

                    {/* Water Areas Layer */}
                    <div className="flex items-center justify-between p-3 bg-gradient-to-r from-cyan-50 to-blue-50 rounded-xl border border-cyan-100">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-cyan-100 rounded-lg flex items-center justify-center">
                          <svg className="w-5 h-5 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                          </svg>
                        </div>
                        <div>
                          <p className="font-semibold text-gray-800">พื้นที่แหล่งน้ำธรรมชาติ</p>
                          <p className="text-xs text-gray-600">แสดงสระและอ่างเก็บน้ำธรรมชาติ กทม.</p>
                        </div>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={waterAreasLayerVisible}
                          onChange={toggleWaterAreasLayer}
                        />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                      </label>
                    </div>

                    {/* Bangkok Expressway Layer */}
                    <div className="flex items-center justify-between p-3 bg-gradient-to-r from-red-50 to-pink-50 rounded-xl border border-red-100">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                          <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m0 0L9 7" />
                          </svg>
                        </div>
                        <div>
                          <p className="font-semibold text-gray-800">เส้นทางด่วน กรุงเทพฯ</p>
                          <p className="text-xs text-gray-600">แสดงเส้นทางด่วนของ กทพ.</p>
                        </div>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={expresswayLayerVisible}
                          onChange={toggleExpresswayLayer}
                        />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                      </label>
                    </div>

                    {/* Color Legend */}
                    <div className="bg-gray-50 rounded-xl p-3">
                      <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                        <svg className="w-4 h-4 mr-2 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                        </svg>
                        สีของเส้นทางรถไฟ
                      </h4>
                      <div className="grid grid-cols-2 gap-2 text-xs">
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-2 rounded" style={{backgroundColor: '#4ECDC4'}}></div>
                          <span>สายใต้ (S)</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-2 rounded" style={{backgroundColor: '#45B7D1'}}></div>
                          <span>สายเหนือ (N)</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-2 rounded" style={{backgroundColor: '#96CEB4'}}></div>
                          <span>สายตะวันออกเฉียงเหนือ (NE)</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-2 rounded" style={{backgroundColor: '#FFEAA7'}}></div>
                          <span>สายตะวันออก (E)</span>
                        </div>
                      </div>
                    </div>

                    {/* Industry Color Legend */}
                    <div className="bg-emerald-50 rounded-xl p-3 border border-emerald-100">
                      <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                        <svg className="w-4 h-4 mr-2 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m0 0L9 7" />
                        </svg>
                        สีการใช้ประโยชน์ที่ดิน
                      </h4>
                      <div className="grid grid-cols-1 gap-1 text-xs">
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-2 bg-red-500 rounded"></div>
                          <span>พื้นที่อุตสาหกรรม</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-2 bg-yellow-500 rounded"></div>
                          <span>พื้นที่พาณิชยกรรม</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-2 bg-orange-500 rounded"></div>
                          <span>พื้นที่ที่อยู่อาศัย</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-2 bg-green-500 rounded"></div>
                          <span>พื้นที่เกษตรกรรม</span>
                        </div>
                      </div>
                    </div>

                    {/* Water Areas Color Legend */}
                    <div className="bg-cyan-50 rounded-xl p-3 border border-cyan-100">
                      <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                        <svg className="w-4 h-4 mr-2 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                        </svg>
                        สีของแหล่งน้ำธรรมชาติ
                      </h4>
                      <div className="grid grid-cols-1 gap-1 text-xs">
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-2 rounded" style={{backgroundColor: '#4A90E2'}}></div>
                          <span>สระน้ำธรรมชาติ</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-2 rounded" style={{backgroundColor: '#1E88E5'}}></div>
                          <span>อ่างเก็บน้ำธรรมชาติ</span>
                        </div>
                      </div>
                    </div>

                    {/* Expressway Color Legend */}
                    <div className="bg-purple-50 rounded-xl p-3 border border-purple-100">
                      <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                        <svg className="w-4 h-4 mr-2 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 713 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m0 0L9 7" />
                        </svg>
                        สีเส้นทางด่วน กรุงเทพฯ
                      </h4>
                      <div className="grid grid-cols-1 gap-1 text-xs">
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-2 rounded" style={{backgroundColor: '#9013FE'}}></div>
                          <span>เส้นทางด่วนของ กทพ.</span>
                        </div>
                      </div>
                    </div>

                    {/* Close Button */}
                    <button
                      onClick={() => setIsNgisExpanded(false)}
                      className="w-full py-2 bg-gradient-to-r from-gray-100 to-gray-200 hover:from-gray-200 hover:to-gray-300 rounded-lg text-sm font-medium text-gray-700 transition-all duration-200 flex items-center justify-center space-x-2"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                      <span>ปิดแผง</span>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Map Type Button */}
        <div className="w-18 h-auto mx-auto absolute top-[9rem] right-4 z-10 flex flex-col items-center justify-center">
          <div
            className="h-auto w-full flex items-center justify-center cursor-pointer drop-shadow-xl"
            onClick={handleChangeTypeOfGoogleMap}
          >
            <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-3d z-10">
              <img
                src="https://cdn-icons-png.flaticon.com/128/14056/14056826.png"
                alt="Map Icon"
                className="w-8 h-8"
              />
            </div>
          </div>
        </div>

        {/* Switch View Button */}
        {statusHalfGridMap && (
          <div className="w-18 h-auto mx-auto absolute top-[9rem] left-5 z-10 flex flex-col items-center justify-center">
            <motion.div
              ref={elementRef}
              className="fixed left-1 h-auto cursor-pointer bg-blue-600 bg-opacity-70 p-4 rounded-md shadow-md"
              style={{ top: "11rem", width: "4.5rem" }}
              onClick={changeStatusMap}
              drag
              dragConstraints={constraints}
            >
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center drop-shadow-xl">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/238/238788.png"
                  className="w-6 h-6"
                  alt="change-status-map-icon"
                />
              </div>
              <p className="text-xs text-white mt-1 text-center">สลับมุมมอง</p>
            </motion.div>
            {!isCheckedCircle && (
              <motion.div
                className="fixed left-1 h-auto cursor-pointer bg-blue-600 bg-opacity-70 p-4 rounded-md shadow-md"
                style={{ top: '24rem', width: '4.5rem' }}
                onClick={handleCheckboxCircleChange}
                drag
                dragConstraints={constraints}
              >
                <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center drop-shadow-xl">
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/6633/6633300.png"
                    className="w-6 h-6"
                    alt="change-status-map-icon"
                  />
                </div>
                <p className="text-xs text-white mt-1 text-center">ค้นหารอบรัศมี</p>
              </motion.div>
            )}
          </div>
        )}

        {/* Pan to User Location */}
        <div className="w-18 h-auto mx-auto absolute top-[12rem] right-4 z-10 flex flex-col items-center justify-center mt-2">
          <div
            className="h-auto w-full flex items-center justify-center cursor-pointer drop-shadow-xl mb-1"
            onClick={panToUserLocation}
          >
            <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-3d">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3138/3138801.png"
                className="w-8 h-8"
                alt="pan-to-user-location-icon"
              />
            </div>
          </div>
        </div>

        {/* Filter Modal */}
        {isModalSearchFilter && (
          <FilterPanel
            typeRealEstateSelected={typeRealEstateSelected}
            typePostRealEstate={searchDataFilter.typePostRealEstate}
            handleClearFilterSearch={handleClearFilterSearch}
            typerealEstateSearchHandle={typerealEstateSearchHandle}
            setSearchDatafilter={setSearchDatafilter}
            searchDataFilter={searchDataFilter}
            provinceData={provinceData}
            handleCallAmpuhre={handleCallAmpuhre}
            districtsData={districtsData}
            handleCallTambon={handleCallTambon}
            TambonData={TambonData}
            handleSetTambonSearchDataFilter={handleSetTambonSearchDataFilter}
            stausRoleSellerSearchFilterSelected={stausRoleSellerSearchFilterSelected}
            RoleSellerEstaeHandle={RoleSellerEstaeHandle}
            isStatusRealEstateFirstHand={isStatusRealEstateFirstHand}
            StatusRealEstateFirstHandHandle={StatusRealEstateFirstHandHandle}
            handlePriceSearch={handlePriceSearch}
            priceValue={priceValue}
            handleSearchFilther={handleSearchFilther}
            handleCloseModal={() => setIsModalSearchFilter(false)}
          />
        )}

        {/* NGIS Modal */}
        {isNgisExpanded && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 lg:hidden">
            <div className="bg-white rounded-3xl shadow-2xl max-w-lg w-full max-h-[75vh] overflow-y-auto transform transition-all duration-300 scale-100 opacity-100">
              <div className="p-6 space-y-6">
                {/* Header */}
                <div className="text-center border-b pb-4 relative">
                  <button
                    onClick={() => setIsNgisExpanded(false)}
                    className="absolute top-0 right-0 w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors"
                  >
                    <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
                    ระบบข้อมูลภูมิสารสนเทศ
                  </h3>
                  <p className="text-sm text-gray-600 mt-2">National Geographic Information System</p>
                </div>
                
                {/* Railway Layer */}
                <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-4 border border-blue-100">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-4">
                      <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                        <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-bold text-gray-800 text-lg">เส้นทางรถไฟ</p>
                        <p className="text-sm text-gray-600">แสดงเส้นทางรถไฟทั่วประเทศไทย</p>
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={railwayLayerVisible}
                        onChange={toggleRailwayLayer}
                      />
                      <div className="w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[26px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                  </div>
                  
                  {/* Railway Color Legend */}
                  <div className="bg-white/70 rounded-xl p-4">
                    <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                      <svg className="w-5 h-5 mr-2 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                      </svg>
                      สีของเส้นทางรถไฟ
                    </h4>
                    <div className="grid grid-cols-2 gap-3">
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-3 rounded-full" style={{backgroundColor: '#4ECDC4'}}></div>
                        <span className="text-sm font-medium">สายใต้ (S)</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-3 rounded-full" style={{backgroundColor: '#45B7D1'}}></div>
                        <span className="text-sm font-medium">สายเหนือ (N)</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-3 rounded-full" style={{backgroundColor: '#96CEB4'}}></div>
                        <span className="text-sm font-medium">สายตะวันออกเฉียงเหนือ (NE)</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-3 rounded-full" style={{backgroundColor: '#FFEAA7'}}></div>
                        <span className="text-sm font-medium">สายตะวันออก (E)</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Industry Layer */}
                <div className="bg-gradient-to-r from-emerald-50 to-green-50 rounded-2xl p-4 border border-emerald-100">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-4">
                      <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
                        <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-bold text-gray-800 text-lg">พื้นที่อุตสาหกรรม</p>
                        <p className="text-sm text-gray-600">แสดงการใช้ประโยชน์ที่ดินอุตสาหกรรม</p>
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={industryLayerVisible}
                        onChange={toggleIndustryLayer}
                      />
                      <div className="w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[26px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                  </div>

                  {/* Industry Color Legend */}
                  <div className="bg-white/70 rounded-xl p-4">
                    <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                      <svg className="w-5 h-5 mr-2 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m0 0L9 7" />
                      </svg>
                      สีการใช้ประโยชน์ที่ดิน
                    </h4>
                    <div className="grid grid-cols-1 gap-2">
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-3 bg-red-500 rounded-full"></div>
                        <span className="text-sm font-medium">พื้นที่อุตสาหกรรม</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-3 bg-yellow-500 rounded-full"></div>
                        <span className="text-sm font-medium">พื้นที่พาณิชยกรรม</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-3 bg-orange-500 rounded-full"></div>
                        <span className="text-sm font-medium">พื้นที่ที่อยู่อาศัย</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-3 bg-green-500 rounded-full"></div>
                        <span className="text-sm font-medium">พื้นที่เกษตรกรรม</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Water Areas Layer */}
                <div className="bg-gradient-to-r from-cyan-50 to-blue-50 rounded-2xl p-4 border border-cyan-100">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-4">
                      <div className="w-12 h-12 bg-cyan-100 rounded-xl flex items-center justify-center">
                        <svg className="w-6 h-6 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-bold text-gray-800 text-lg">พื้นที่แหล่งน้ำธรรมชาติ</p>
                        <p className="text-sm text-gray-600">แสดงสระและอ่างเก็บน้ำธรรมชาติ กทม.</p>
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={waterAreasLayerVisible}
                        onChange={toggleWaterAreasLayer}
                      />
                      <div className="w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[26px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                  </div>
                  
                  {/* Water Areas Color Legend */}
                  <div className="bg-white/70 rounded-xl p-4">
                    <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                      <svg className="w-5 h-5 mr-2 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                      </svg>
                      สีของแหล่งน้ำธรรมชาติ
                    </h4>
                    <div className="grid grid-cols-1 gap-2">
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-3 rounded-full" style={{backgroundColor: '#4A90E2'}}></div>
                        <span className="text-sm font-medium">สระน้ำธรรมชาติ</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-3 rounded-full" style={{backgroundColor: '#1E88E5'}}></div>
                        <span className="text-sm font-medium">อ่างเก็บน้ำธรรมชาติ</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bangkok Expressway Layer */}
                <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-4 border border-purple-100">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-4">
                      <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center">
                        <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 713 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m0 0L9 7" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-bold text-gray-800 text-lg">เส้นทางด่วน กรุงเทพฯ</p>
                        <p className="text-sm text-gray-600">แสดงเส้นทางด่วนของ กทพ.</p>
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={expresswayLayerVisible}
                        onChange={toggleExpresswayLayer}
                      />
                      <div className="w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[26px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                  </div>
                  
                  {/* Expressway Color Legend */}
                  <div className="bg-white/70 rounded-xl p-4">
                    <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                      <svg className="w-5 h-5 mr-2 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 713 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m0 0L9 7" />
                      </svg>
                      สีเส้นทางด่วน กรุงเทพฯ
                    </h4>
                    <div className="grid grid-cols-1 gap-2">
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-3 rounded-full" style={{backgroundColor: '#9013FE'}}></div>
                        <span className="text-sm font-medium">เส้นทางด่วนของ กทพ.</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex space-x-3 pt-4">
                  <button
                    onClick={() => {
                      setRailwayLayerVisible(false);
                      setIndustryLayerVisible(false);
                      setWaterAreasLayerVisible(false);
                      setExpresswayLayerVisible(false);
                      // Clear layers if active
                      if (map && railwayDataRef.current) {
                        map.data.forEach((feature) => {
                          map.data.remove(feature);
                        });
                      }
                      if (map && waterAreasDataRef.current) {
                        map.data.forEach((feature) => {
                          const waterBodyType = feature.getProperty('wb_type');
                          if (waterBodyType === 6 || waterBodyType === 7) {
                            map.data.remove(feature);
                          }
                        });
                      }
                      if (map && expresswayDataRef.current) {
                        map.data.forEach((feature) => {
                          const expresswayName = feature.getProperty('name') || feature.getProperty('Name') || feature.getProperty('NAME');
                          if (expresswayName && feature.getGeometry().getType().includes('LineString')) {
                            map.data.remove(feature);
                          }
                        });
                      }
                      if (map && wmsMapTypeRef.current) {
                        map.overlayMapTypes.clear();
                      }
                    }}
                    className="flex-1 py-3 bg-gradient-to-r from-red-100 to-red-200 hover:from-red-200 hover:to-red-300 rounded-xl text-red-700 font-medium transition-all duration-200 flex items-center justify-center space-x-2"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                    <span>ล้างทั้งหมด</span>
                  </button>
                  <button
                    onClick={() => setIsNgisExpanded(false)}
                    className="flex-1 py-3 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 rounded-xl text-white font-medium transition-all duration-200 flex items-center justify-center space-x-2"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>เสร็จสิ้น</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </GoogleMap>
    </div>
  ) : (
    <div className="w-full h-screen flex justify-center items-center">
      กำลังโหลดแผนที่...
    </div>
  );
}

export default GoogleMapEmbedAPIReact;